import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Icon from 'modules/Icon';

interface PageTitleProps {
  title: string;
  description?: string;
  icon?: IconProp;
}

const PageTitle = ({ title, description, icon }: PageTitleProps) => {
  return (
    <div className="br-pagetitle mb-3">
      {icon && <Icon type={icon} />}
      <div className={!icon ? 'pl-0' : ''}>
        <h4>{title}</h4>
        {description && <p className="mg-b-0">{description}</p>}
      </div>
    </div>
  );
};

export default PageTitle;
